import { render, staticRenderFns } from "./correct2.vue?vue&type=template&id=38da74f2&scoped=true&"
import script from "./correct2.vue?vue&type=script&lang=js&"
export * from "./correct2.vue?vue&type=script&lang=js&"
import style0 from "./correct2.vue?vue&type=style&index=0&id=38da74f2&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38da74f2",
  null
  
)

export default component.exports